import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  createFilterOptions,
} from "@mui/material";
import TableContent from "../../table/table";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { useDispatch, useSelector } from "react-redux";
import {
  CreateAttendenceAction,
  DeleteAttendenceAction,
  GetAllAttendenceAction,
  UpdateAttendenceAction,
} from "../../../../redux/actions/AttendenceActions";
import { GetAllEmployeeAction } from "../../../../redux/actions/employeeActions";
import notify from "../../../Notifcation";
import { useReactToPrint } from "react-to-print";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../Utility/Pagination/Pagination";
import { useTableExcelExport } from "../../../Utility/useTableExcelExport";
import FormPrintView from "../../../Utility/FormPrintView/FormPrintView";
import {
  formatPrintDate,
  formatPrintTime,
  formatPrintValue,
  filterByEmployeeName,
  getAttendanceStatusLabel,
} from "../../../Utility/FormPrintView/formPrintHelpers";
import dayjs from "dayjs";
const filter = createFilterOptions();

const Enter = ({
  userData,
  key,
  setKey,
  Datee,
  setDate,
  StatusAttende,
  setStatusAttende,
  time,
  settime,
  Day,
  setDay,
  empname,
  setempname,
  isEdit,
  setIsEdit,
  AttendenceId,
  setAttendenceId,
  EmployeesId,
  setEmployeesId,
  Note,
  setNote,
  setCreatedbyUserId,
  CreatedbyUserId,
  setEye,
  Eye,
}) => {
  const dispatch = useDispatch();
  const [Search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const AllEmplyee = useSelector((state) => state.EmployeeR.GetEmployee);
  const myDivRefWorkcom = useRef();
  const { tableRef, onDownload } = useTableExcelExport(
    "بيانات الحضور",
    "بيانات الحضور",
  );

  const All = useSelector((state) => state.AttendenceR.GetAttendence);
  const PageSize = 7;

  const buildSearchQuery = (page = 1) => {
    const query = { pageNumber: page, pageSize: PageSize };
    if (Search.trim()) query.searchTerm = Search.trim();
    return query;
  };

  const filteredAttendance = filterByEmployeeName(All?.data, Search);

  useEffect(() => {
    dispatch(GetAllEmployeeAction());
    dispatch(GetAllAttendenceAction(buildSearchQuery()));
  }, []);

  const handleSearch = async () => {
    await dispatch(GetAllAttendenceAction(buildSearchQuery()));
  };

  const [showDelete, setshowDelete] = useState(false);
  const onPress = async (page) => {
    await dispatch(GetAllAttendenceAction(buildSearchQuery(page)));
  };
  const current = All?.currentPage;

  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setAttendenceId(itemid);
  };

  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteAttendenceAction(AttendenceId));
    setLoading(false);
    setAttendenceId(null);
    setshowDelete(false);
    setIsPress(false);
  };
  const handlePrint = useReactToPrint({
    contentRef: myDivRefWorkcom,
    documentTitle: "بيانات الحضور",
  });

  const handlesubmit = async (e) => {
    e.preventDefault();
    if (
      Datee === "" ||
      EmployeesId === null ||
      StatusAttende === "" ||
      time === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }

    if (userData.subscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      All.data &&
      All.data.length > 4
    ) {
      notify("غير مسموح بأضافة اكثر من 5 عمليات إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      current > 1 &&
      All.data.length > 4
    ) {
      notify("غير مسموح بأضافة اكثر من 5 عمليات إشترك للتفعيل ", "error");
      return;
    }

    setIsPress(true);
    setLoading(true);

    const FormDataa = new FormData();

    FormDataa.append("ApplicationUserId", EmployeesId.id);
    FormDataa.append("Date", Datee);
    FormDataa.append("AttendanceType", StatusAttende);
    FormDataa.append("Time", dayjs(time).format("hh:mm:ss"));
    FormDataa.append("CreatedBy", CreatedbyUserId);
    FormDataa.append("Note", Note);

    // const Data = {
    //   ApplicationUserId: EmployeesId.id,
    //   Date: Datee,
    //   AttendanceType: StatusAttende,
    //   Time: dayjs(time).format("hh:mm:ss"),
    //   CreatedBy: CreatedbyUserId,
    //   Note: Note,
    // };

    await dispatch(CreateAttendenceAction(FormDataa));
    setEmployeesId("");
    setDate("");
    setDay("");
    setStatusAttende("");
    settime("");
    setNote("");
    setIsEdit(false);
    setAttendenceId("");
    setIsPress(false);
    setLoading(false);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (
      Datee === "" ||
      EmployeesId === null ||
      Day === "" ||
      StatusAttende === "" ||
      time === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }

    if (userData.subscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      All.data &&
      All.data.length > 4
    ) {
      notify(
        "غير مسموح بأضافة اكثر من 5 من الحضور او الانصراف إشترك للتفعيل ",
        "error",
      );
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      current > 1 &&
      All.data.length > 4
    ) {
      notify(
        "غير مسموح بأضافة اكثر من 5 من الحضور او الانصراف إشترك للتفعيل ",
        "error",
      );
      return;
    }

    setIsPress(true);
    setLoading(true);

    const Data = {
      applicationUserId: EmployeesId.id,
      date: Datee,
      attendanceType: StatusAttende,
      time: dayjs(time).format("hh:mm:ss"),
      createdBy: CreatedbyUserId,
      note: Note,
      id: AttendenceId,
    };
    await dispatch(UpdateAttendenceAction(Data));
    setEmployeesId("");
    setEmployeesId("");
    setDate("");
    setDay("");
    setStatusAttende("");
    settime("");
    setNote("");
    setAttendenceId("");
    setIsPress(false);
    setIsEdit(false);
    setLoading(false);
  };

  const Update = (item) => {
    setEmployeesId({
      name: item.employeeName,
      id: item.employeeId,
    });
    setStatusAttende(item.attendanceType);
    setDay(item.day);
    setNote(item.note);
    setAttendenceId(item.id);
    setDate(item.date.split("T")[0]);
    settime(dayjs(`1970-01-01T${item.time}`));
    setAttendenceId(item.id);
    setIsEdit(true);
    setEye(false);
  };
  const Showw = (item) => {
    setEmployeesId({
      name: item.employeeName,
      id: item.employeeId,
    });
    setDay(item.day);
    setStatusAttende(item.attendanceType);
    setNote(item.note);
    setAttendenceId(item.id);
    setDate(item.date.split("T")[0]);
    settime(dayjs(`1970-01-01T${item.time}`));
    setAttendenceId(item.id);
    setIsEdit(false);
    setEye(true);
  };

  const res = useSelector((state) => state.AttendenceR.AddAttendence);
  const UP = useSelector((state) => state.AttendenceR.UpdateAttendence);
  const DEL = useSelector((state) => state.AttendenceR.DeleteAttendence);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.responseMessage ===
              "Great, attendance created Successfully"
          ) {
            dispatch(GetAllAttendenceAction(buildSearchQuery()));
            notify("تم اضافة البيانات بنجاح", "success");
          }
          if (
            res.data &&
            res.data.responseMessage ===
              "sorry, this user have an exist attendance today"
          ) {
            dispatch(GetAllAttendenceAction(buildSearchQuery()));
            notify("هذا الموظف تم اثبات حضورة بالفعل ", "warn");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.status === 200 || UP.status === 201) {
          if (
            UP.data &&
            UP.data.responseMessage === "Great, attendance updated Successfully"
          ) {
            dispatch(GetAllAttendenceAction(buildSearchQuery()));
            notify("تم تحديث البيانات بنجاح", "success");
          }
        } else if (UP.status !== 200 || UP.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (DEL) {
        if (DEL.statusCode === 200 || DEL.statusCode === 201) {
          if (
            DEL &&
            DEL.responseMessage === "Great, attendance deleted successfully"
          ) {
            dispatch(GetAllAttendenceAction(buildSearchQuery()));
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.statusCode !== 200 || DEL.statusCode !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <div className="dateee">{Datee ? Datee : null}</div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    التاريخ
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                type="date"
                value={Datee}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <Autocomplete
                value={EmployeesId}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setEmployeesId({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setEmployeesId({
                      name: newValue.inputValue,
                    });
                  } else {
                    setEmployeesId(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name,
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={
                  Array.isArray(AllEmplyee && AllEmplyee.data)
                    ? AllEmplyee.data.filter((e) => e.isAccountActive === true)
                    : []
                }
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.name;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.name}</li>
                )}
                sx={{ width: 300 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        اسم الموظف
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                  />
                )}
              />
            </div>
            {/* <div className="inp-container">
              <TextField
                
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    أسم الموظف
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                //   className="ww"
              />
            </div> */}
            {/* <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {" "}
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    اليوم
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Day}
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      اليوم
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  onChange={(e) => setDay(e.target.value)}>
                  <MenuItem value={"الأحد"}>الأحد</MenuItem>
                  <MenuItem value={"الأثنين"}>الأثنين</MenuItem>
                  <MenuItem value={"الثلاثاء"}>الثلاثاء</MenuItem>
                  <MenuItem value={"الأربعاء"}>الأربعاء</MenuItem>
                  <MenuItem value={"الخميس"}>الخميس</MenuItem>
                  <MenuItem value={"الجمعة"}>الجمعة</MenuItem>
                  <MenuItem value={"السبت"}>السبت</MenuItem>
                </Select>
              </FormControl>
            </div> */}

            <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {" "}
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    الحالة
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={StatusAttende}
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      الحالة
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  onChange={(e) => setStatusAttende(e.target.value)}>
                  <MenuItem value={"Presence"}>حضور</MenuItem>
                  <MenuItem value={"Departure"}>انصراف</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="inp-container clock">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["TimePicker"]}>
                  <TimePicker
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        التوقيت
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    defaultValue={""}
                    value={time}
                    onChange={(newValue) => settime(newValue)}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>
            <div className="inp-container">
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    إدخال بواسطة
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                disabled
                value={userData.name}
                focused
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label={"ملاحظات"}
                variant="outlined"
                type="text"
                value={Note}
                onChange={(e) => setNote(e.target.value)}
              />
            </div>

            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? (
            <button className="buttonadd" onClick={handlePrint}>
              تصدير
            </button>
          ) : (
            <>
              {isEdit ? (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}{" "}
          <div className="inputs-container ddl">
            <div className="inp-container ">
              <TextField
                label="ابحث"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSearch();
                }}
                value={Search}
              />
              <i
                className="ty fa-solid fa-magnifying-glass"
                onClick={handleSearch}></i>
            </div>
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          <button className="buttonadd" type="button" onClick={handleSearch}>
            بحث
          </button>
        </Container>{" "}
        <Table
          ref={tableRef}
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                التاريخ<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                اسم الموظف <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                الحالة <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                الوقت<i className="fa-solid fa-hashtag"></i>
              </th>
              <th className="col-review">
                بواسطة <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ملاحظات <i className="fa-regular fa-calendar-check"></i>
              </th>

              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {filteredAttendance.length > 0
              ? filteredAttendance.map((item, idx) => {
                  // ForceCount = ALL.TotalPages - 1;
                  return (
                    <tr key={idx} onDoubleClick={() => Update(item)}>
                      <td>{new Date(item.date).toLocaleDateString("en-GB")}</td>
                      <td>{item.employeeName}</td>
                      <td>
                        {item.attendanceType === "Presence"
                          ? "حضور"
                          : item.attendanceType === "Departure"
                            ? "انصراف"
                            : ""}
                      </td>
                      <td>{item.time}</td>
                      <td className="col-review" title={item.createdByName}>
                        {item.createdByName}
                      </td>
                      <td>{item.note}</td>
                      <td className="icon-w" onClick={() => Update(item)}>
                        <i
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        {" "}
                        <i
                          onClick={() => handleShoweDelete(item.id)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => Showw(item)}
                          className="fa-solid fa-eye"
                          style={{ color: "#333" }}></i>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>
        {/* <TableContent
          tablecontent={[
            { name: "", icon: <i className="fa-solid fa-hashtag"></i> },
            // { name: "بواسطة", icon: <i className="fa-solid fa-user"></i> },
            { name: "اسم الموظف", icon: <i className="fa-solid fa-user"></i> },
            {
              name: "اليوم",
              icon: <i className="fa-solid fa-calendar-days"></i>,
            },
            {
              name: "التاريخ",
              icon: <i className="fa-solid fa-calendar-days"></i>,
            },
            {
              name: "الحالة",
              icon: <i className="fa-solid fa-layer-group"></i>,
            },
            {
              name: "حضور",
              icon: <i className="fa-solid fa-layer-group"></i>,
            },
            {
              name: "انصراف",
              icon: <i className="fa-solid fa-layer-group"></i>,
            },
            {
              name: "عدد الساعات",
              icon: <i className="fa-solid fa-layer-group"></i>,
            },
            {
              name: "وقت اضافي",
              icon: <i className="fa-solid fa-layer-group"></i>,
            },
            {
              name: "عدد ساعات التأخير",
              icon: <i className="fa-solid fa-layer-group"></i>,
            },
            // {
            //   name: "نوع الدعوى",
            //   icon: <i className="fa-solid fa-school"></i>,
            // },
            // {
            //   name: "رقم التسوية",
            //   icon:<i className="fa-solid fa-hashtag"></i>,
            // },
            // {
            //   name: "المحكمة",
            //   icon:   <i className="fa-solid fa-scale-balanced"></i>,
            // },
            {
              name: "",
            },
            {
              name: "",
            },
            {
              name: "",
            },
          ]}
          data={[9, 10, 11]}
        /> */}
        <ToastContainer autoClose={1200} />
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={All ? All.totalPages : null}
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        />
        <button className="buttonadd" onClick={onDownload}>
          تصدير
        </button>
      </div>
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
                      <Modal.Title> </Modal.Title>
                    </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <FormPrintView
        ref={myDivRefWorkcom}
        title="إدارة حضور وانصراف"
        fields={[
          { label: "التاريخ", value: formatPrintDate(Datee) },
          { label: "اسم الموظف", value: formatPrintValue(EmployeesId) },
          // { label: "اليوم", value: formatPrintValue(Day) },
          { label: "الحالة", value: getAttendanceStatusLabel(StatusAttende) },
          { label: "التوقيت", value: formatPrintTime(time) },
          { label: "إدخال بواسطة", value: formatPrintValue(userData?.name) },
          { label: "ملاحظات", value: formatPrintValue(Note) },
        ]}
      />
    </>
  );
};
export default Enter;
